export const APP_DEFAULT_PATH = '/dashboard';